import { createAction, props } from '@ngrx/store';

import { Activity } from 'app/shared/features/activity-selector/models';

export const updateActivities = createAction(
    '[Activity] Update Activities',
    props<{ activityList: Activity[] }>(),
);
